import i from "./internal/_curry1.mjs";
var u = /* @__PURE__ */ i(function(r) {
  return r == null;
});
export {
  u as default
};
